// Actiondan gelen datalar ile stateler güncellenecek
export const accountLoading = (state, payload) => {
    state.loading = payload
}

export const getAccountNo = (state, payload) => {
    if(payload)
     state.newAccountNo = payload.data
}

export const getAccountDetail = (state, payload) => {
    state.accountDetail = payload.data
}

export const accountInfo = (state, payload) => {
    state.accountId = payload.data ? payload.data : payload
}

export const accountStatusNull = (state, payload) => {
    state.status = {}
}

export const setAccountStatus = (state, payload) => {
    if(payload.data){
        state.status = payload.data ? payload.data : payload
    }
    
}

export const accountZones = (state, payload) => {
    state.zones = payload.data
}

export const accountUser = (state, payload) => {
    state.users =  payload.data
}

export const accountAlertDefs = (state, payload) => {
    state.alertDefs = payload.data
}

export const accountSignalDefs = (state, payload) => {
    state.accountAlertDefs = payload.data
}

export const accountNotes = (state, payload) => {
    state.notes = payload.data
}

export const accountNotifications = (state, payload) => {
    state.notifications = payload.data ? payload.data : []
}

export const accountHours = (state, payload) => {
    state.hours = payload.data
}

export const accountTracings = (state, payload) => {
    state.tracings = payload.data
}

export const accountComs = (state, payload) => {
    state.communications = payload.data
}

export const accounts = (state, payload) => {
    if(payload && payload.data){
        state.accounts = payload.data
        state.accountPageInfo = payload.list_info
    }else{
        state.accounts = []
    }
    //state.status = payload
}
export const accountAddress = (state, payload) => {
    state.accountAddress = payload.data
}
export const accountVacations = (state, payload) => {
    if(payload.data){
        state.accountVacations = payload.data
    }else{
        state.accountVacations = []
    }
}

export const getAccountCameras = (state, payload) => {
    if(payload.data){
        state.accountCameras = payload.data
    }else{
        state.accountCameras = []
    }
}

export const getAccountDevices = (state, payload) => {
    if(payload.data){
        state.accountDevices = payload.data
    }else{
        state.accountDevices = []
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/Alarmsis/Account/Mutaions.js